<!--  -->
<template>
  <div class="icon-module">
    <template v-if="isWuSi">
      <!-- 物思自己的那套 -->
      <template v-if="config.img.url !== 'default'">
        <template
          v-if="
            config.color.value === 'default' ||
            config.isColor === false ||
            config.img.url.includes('confiles') ||
            config.img.url.includes('userfiles')
          "
        >
          <!-- 如果是默认的话  直接展示出来就好了 -->
          <img v-if="config.img.url" class="icon-module-img" :src="$imgurl + '/' + config.img.url" />
        </template>
        <!-- 如果说是修改了颜色  展示还不知道是啥 -->
        <template v-else>
          <img class="icon-module-img" :src="config.img.base64Url" />
        </template>
      </template>
      <template v-else>
        <img class="icon-module-img" v-if="defaultUrl" :src="defaultUrl" />
      </template>
    </template>
    <template v-if="isTiktok">
      <!-- 字节那套展示 -->
      <img class="icon-module-img" :src="config.img.base64Url" />
    </template>
  </div>
</template>

<script>

export default {
  name: 'iconModule',
  components: {},
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    defaultUrl: {
      type: String,
      default: ''
    }
    // config: {
    //     type: 0, // 判断是物思的图标还是字节的 默认0是物思 1是字节
    //     color: {
    //       value: 'default',
    //       type: 'local'
    //     },
    //     img: {
    //       url: '',
    //       mobileUrl: '' // 字节手机端的图标地址
    //     },
    //     iconParkConfig: { // 字节图标的配置
    //       theme: 'outline',
    //       size: 24,
    //       color: '#333',
    //       strokeWidth: 4,
    //       strokeLinecap: 'round', // 端点类型
    //       strokeLinejoin: 'round' // 拐点类型
    //     }
    //   },
  },
  data () {
    return {}
  },
  methods: {},
  watch: {},
  computed: {
    isWuSi () {
      return this.config.type === 0
    },
    isTiktok () {
      return this.config.type === 1
    }
  }
}
</script>
<style lang='scss' scoped>
.icon-module {
  width: 100%;
  height: 100%;
  .el-image {
    width: 100%;
    height: 100%;
  }
  .icon-module-img {
    width: 100%;
    height: 100%;
  }
}
</style>
